import React, { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { notification } from 'antd';

import { BreederAdminsTable, DogParkLayout } from 'dogpark/components';
import { useBreederAdminsContext } from 'dogpark/context';
import { getBreederAdminUsers } from 'dogpark/utilities/breeders';
import { BreedersRouteParams } from 'dogpark/types';
import { useLayoutState } from 'shared/components/layout/useLayoutState';
import { BreadcrumbItem } from 'types';

import { BreederAdminsPageHeader } from './BreederAdminUsers.styles';

const breadcrumbs: BreadcrumbItem[] = [
  {
    key: 'main',
    label: 'Main',
    path: '/',
  },
  {
    key: 'dogPark',
    label: 'DogPark',
  },
  {
    key: 'breederAdmins',
    label: 'Admins',
  },
];

function BreederAdminUsers(): ReactElement {
  const { dispatch: dispatchLayout } = useLayoutState();
  const {
    state: { fetchBreederAdmins },
    dispatch,
  } = useBreederAdminsContext();
  const { searchBy, searchValue } = useParams<BreedersRouteParams>();

  useEffect(() => {
    dispatchLayout({ type: 'SET_BREADCRUMBS', breadcrumbs });
    dispatch({ type: 'SET_FETCH_BREEDER_ADMIN' });
  }, [searchBy, searchValue]);

  useEffect(() => {
    const handleFetchBreederAdmins = async () => {
      try {
        dispatch({ type: 'LOAD_BREEDER_ADMIN' });

        const breederAdmins = await getBreederAdminUsers(searchBy, searchValue);

        dispatch({ type: 'SET_BREEDER_ADMIN', payload: { breederAdmins } });
      } catch (e) {
        e.message &&
          notification.error({ key: 'getBreederAdminsError', message: e.message });
        dispatch({ type: 'SET_BREEDER_ADMIN', payload: { breederAdmins: [] } });
      }
    };
    fetchBreederAdmins && handleFetchBreederAdmins();
  }, [fetchBreederAdmins]);

  return (
    <DogParkLayout>
      <BreederAdminsPageHeader title="Admins" />
      <BreederAdminsTable />
    </DogParkLayout>
  );
}

export default BreederAdminUsers;
